var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPinOutlineBold = function SvgPinOutlineBold(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11048 6.49356L10.6295 4.86816C10.7276 4.80866 10.8112 4.72798 10.8741 4.63203C10.937 4.53608 10.9778 4.42728 10.9933 4.31359C11.0088 4.19989 10.9987 4.08416 10.9637 3.97486C10.9288 3.86556 10.8698 3.76546 10.7912 3.68185L8.31847 1.20909C8.23487 1.13049 8.13476 1.07156 8.02546 1.03661C7.91616 1.00165 7.80044 0.99156 7.68674 1.00706C7.57304 1.02257 7.46424 1.06328 7.36829 1.12622C7.27234 1.18916 7.19167 1.27274 7.13216 1.37086L5.46825 3.85903L2.00946 4.62936C1.93036 4.64855 1.85774 4.68829 1.79893 4.74456C1.74012 4.80082 1.69721 4.87162 1.67454 4.94979C1.65187 5.02796 1.65024 5.11073 1.66983 5.18973C1.68941 5.26873 1.72951 5.34116 1.78606 5.39969L6.5236 10.1449C6.58357 10.1992 6.65653 10.2371 6.73542 10.2549C6.81431 10.2727 6.89647 10.2698 6.97393 10.2466C7.0514 10.2234 7.12156 10.1805 7.17762 10.1222C7.23368 10.0639 7.27374 9.99215 7.29393 9.91383L8.11048 6.49356Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15066 7.82617L1 10.9999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPinOutlineBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin-outline-bold.9a5b429dea0a967e79e23b050d0cbe42.svg";